// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__oI1_z","footer":"ModalUpdate_footer__V8r4F"};